import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';

import { OrderState } from '../../../enums/orders/order-state.enum';

import { OrdersService } from '@ubie/core';

@Component({
  selector: 'acl-order-status',
  templateUrl: './order-status.component.html',
  styleUrl: './order-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderStatusComponent implements OnInit {
  private readonly OrderService = inject(OrdersService);

  readonly orderNo = input.required<string>();
  readonly isLoading = signal(false);
  readonly orderState = signal<OrderState>(OrderState.pending);

  readonly OrderState = OrderState;

  ngOnInit(): void {
    this.getOrderStatus();
  }

  getOrderStatus(): void {
    this.OrderService.getStatus(this.orderNo()).subscribe({
      next: (result) => {
        // show correct message according to the status
        if (result.status?.toString().toLowerCase().endsWith('paid')) {
          this.orderState.set(OrderState.succeeded);
        } else if (
          result.status?.toString().toLowerCase() === 'pending' ||
          result.status?.toString().toLowerCase() === 'open'
        ) {
          this.orderState.set(OrderState.pending);
        } else {
          this.orderState.set(OrderState.failed);
        }
        this.isLoading.set(false);
      },
      error: () => {
        this.isLoading.set(false);
        this.orderState.set(OrderState.error);
      },
    });
  }

  /**
   * Reload page
   */
  onReload(): void {
    this.initLoading();

    setTimeout(() => {
      this.getOrderStatus();
    }, 500);
  }

  initLoading(): void {
    this.isLoading.set(true);
    this.orderState.set(OrderState.pending);
  }
}
